<ag-grid-angular
  class="ag-theme-alpine lty-table"
  style="width: 100%"
  [domLayout]="'autoHeight'"
  [rowData]="rows()"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [context]="context()"
  [rowHeight]="56"
  [animateRows]="false"
  [suppressRowClickSelection]="true"
  [enableCellTextSelection]="true"
  [ensureDomOrder]="true"
  [getRowId]="getRowId"
/>
